import moment from 'moment';

/**
 * <DateConverter 
      timestamp={dueDate}
      format="YYYY-MM-DD"
    />
 * @param {*} props 
 */
function DateConverter(props) {
  const { date, timestamp, format = 'YYYY-MM-DD', replace = null, language = 'en' } = props;

  if (timestamp) {
    return moment.unix(timestamp).locale(language).format(format);
  }

  if (date) {
    return moment(date).locale(language).format(format);
  }

  return replace;
}

export default DateConverter;
